var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting_content" },
    [
      _c("div", { staticClass: "setting_content_main" }, [
        _c("form", { on: { change: _vm.logChangeData } }, [
          _c("div", { staticClass: "setting_content_heading" }, [
            _c("h2", { staticClass: "setting_content_title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.labelProperties.HEAD_TITLE) +
                  "\n        "
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit" }, [
            _c("p", { staticClass: "setting_unit_title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.labelProperties.SOCIAL_NAME_SETTING) +
                  "\n        "
              )
            ]),
            _c("div", { staticClass: "setting_unit_item" }, [
              _c("p", { staticClass: "setting_unit_label" }, [
                _vm._v(_vm._s(_vm.labelProperties.COMPANY_NAME))
              ]),
              _c(
                "div",
                { staticClass: "setting_unit_form" },
                [
                  _c(
                    "draggable",
                    {
                      attrs: {
                        list: _vm.displaySetting.companyPublicSettings,
                        draggable: ".item",
                        group: {
                          name: "item-job",
                          put: _vm.checkSettingsLength(1) === 0
                        }
                      },
                      on: {
                        change: _vm.logChangeData,
                        add: function($event) {
                          return _vm.addItemToDisplaySetting(1)
                        }
                      }
                    },
                    [
                      _vm._l(_vm.displaySetting.companyPublicSettings, function(
                        companyPublicSetting,
                        index
                      ) {
                        return _c("div", { key: index, staticClass: "item" }, [
                          companyPublicSetting &&
                          !companyPublicSetting.itemResourceDeleted
                            ? _c(
                                "div",
                                { staticClass: "setting_form_wrapper" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          companyPublicSetting.display_name,
                                        expression:
                                          "companyPublicSetting.display_name"
                                      }
                                    ],
                                    staticClass: "setting_form_text",
                                    attrs: {
                                      type: "text",
                                      placeholder:
                                        _vm.labelProperties.PLACE_HOLDER,
                                      readonly: ""
                                    },
                                    domProps: {
                                      value: companyPublicSetting.display_name
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          companyPublicSetting,
                                          "display_name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "setting_form_wrapper_close",
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteItemSetting(index, 1)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "12",
                                            height: "12",
                                            xmlns: "http://www.w3.org/2000/svg"
                                          }
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                fill: "none",
                                                "fill-rule": "evenodd"
                                              }
                                            },
                                            [
                                              _c("rect", {
                                                attrs: {
                                                  fill: "#555",
                                                  width: "12",
                                                  height: "12",
                                                  rx: "2"
                                                }
                                              }),
                                              _c(
                                                "g",
                                                { attrs: { fill: "#FFF" } },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                                    }
                                                  }),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      }),
                      _vm.checkSettingsLength(1) === 0
                        ? _c(
                            "div",
                            {
                              staticClass: "setting_form_wrapper",
                              attrs: { slot: "footer" },
                              slot: "footer"
                            },
                            [
                              _c("input", {
                                staticClass: "setting_form_text",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.labelProperties.PLACE_HOLDER,
                                  readonly: ""
                                }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ]),
          _c("div", { staticClass: "setting_unit" }, [
            _c("p", { staticClass: "setting_unit_title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.labelProperties.HOME_PAGE_POSTING_SETTING) +
                  "\n        "
              )
            ]),
            _c("div", { staticClass: "setting_unit_item" }, [
              _c("p", { staticClass: "setting_unit_label" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.labelProperties.HOME_PAGE_POSTING) +
                    "\n          "
                )
              ]),
              _c(
                "div",
                { staticClass: "setting_unit_form" },
                [
                  _c(
                    "draggable",
                    {
                      attrs: {
                        list: _vm.displaySetting.homepagePostingSettings,
                        draggable: ".item",
                        group: {
                          name: "item-job",
                          put: _vm.checkSettingsLength(2) === 0
                        }
                      },
                      on: {
                        change: _vm.logChangeData,
                        add: function($event) {
                          return _vm.addItemToDisplaySetting(2)
                        }
                      }
                    },
                    [
                      _vm._l(
                        _vm.displaySetting.homepagePostingSettings,
                        function(homepagePosting, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "item" },
                            [
                              homepagePosting &&
                              !homepagePosting.itemResourceDeleted
                                ? _c(
                                    "div",
                                    { staticClass: "setting_form_wrapper" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: homepagePosting.display_name,
                                            expression:
                                              "homepagePosting.display_name"
                                          }
                                        ],
                                        staticClass: "setting_form_text",
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            _vm.labelProperties.PLACE_HOLDER,
                                          readonly: ""
                                        },
                                        domProps: {
                                          value: homepagePosting.display_name
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              homepagePosting,
                                              "display_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "setting_form_wrapper_close",
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteItemSetting(
                                                index,
                                                2
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                width: "12",
                                                height: "12",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c(
                                                "g",
                                                {
                                                  attrs: {
                                                    fill: "none",
                                                    "fill-rule": "evenodd"
                                                  }
                                                },
                                                [
                                                  _c("rect", {
                                                    attrs: {
                                                      fill: "#555",
                                                      width: "12",
                                                      height: "12",
                                                      rx: "2"
                                                    }
                                                  }),
                                                  _c(
                                                    "g",
                                                    { attrs: { fill: "#FFF" } },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M2.853 3.893l.99-.99 5.304 5.304-.99.99z"
                                                        }
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M8.157 2.903l.99.99-5.304 5.304-.99-.99z"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        }
                      ),
                      _vm.checkSettingsLength(2) === 0
                        ? _c(
                            "div",
                            {
                              staticClass: "setting_form_wrapper",
                              attrs: { slot: "footer" },
                              slot: "footer"
                            },
                            [
                              _c("input", {
                                staticClass: "setting_form_text",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.labelProperties.PLACE_HOLDER,
                                  readonly: ""
                                },
                                on: { change: _vm.logChangeData }
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _c("DragDropComponent", {
        attrs: {
          groupName: _vm.groupName,
          jobCategories: _vm.jobCategories,
          property: _vm.property,
          resourceFields: _vm.resourceFields,
          useType: _vm.useType,
          idSetScroll: _vm.idSetScroll,
          isDispatch: true
        },
        on: {
          updatedProperty: _vm.updatedProperty,
          refreshResourceList: _vm.refreshResourceList,
          getJobResourceFields: _vm.getJobResourceFields
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }